
define('text!templates/errors/500-page.ejs',[],function () { return '500';});

